import { Link } from "react-router-dom";
import { BRAND } from "../data/content";
import { LEGAL } from "../lib/legalConfig";
import { IDS } from "../lib/testIds";
import { openConsentPreferences } from "../lib/consent";
import BrandLogo from "./BrandLogo";
import NewsletterForm from "./NewsletterForm";

const FOCUS_CREAM =
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-3 focus-visible:outline-lemon";

export default function Footer() {
  return (
    <footer
      data-testid={IDS.footer.root}
      className="bg-navy text-cream mt-24 md:mt-32"
    >
      <div className="page-container py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-6">
            <BrandLogo
              className="text-cream"
              wordClassName="text-6xl md:text-8xl leading-[0.9]"
            />
            <p className="mt-6 font-display italic text-xl md:text-2xl text-cream/80 max-w-md leading-snug">
              {BRAND.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-overline uppercase text-cream/70 mb-4">Contenuti</div>
            <ul className="space-y-3 text-cream/90">
              <li><Link to="/guide" className={`link-underline rounded-sm ${FOCUS_CREAM}`}>Guide</Link></li>
              <li><Link to="/gadget" className={`link-underline rounded-sm ${FOCUS_CREAM}`}>Gadget</Link></li>
              <li><Link to="/metodo" className={`link-underline rounded-sm ${FOCUS_CREAM}`}>Metodo</Link></li>
              <li><Link to="/chi-sono" className={`link-underline rounded-sm ${FOCUS_CREAM}`}>Chi sono</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-overline uppercase text-cream/70 mb-4">Legale</div>
            <ul className="space-y-3 text-cream/90">
              <li><Link to="/privacy" className={`link-underline rounded-sm ${FOCUS_CREAM}`}>Privacy</Link></li>
              <li><Link to="/cookie" className={`link-underline rounded-sm ${FOCUS_CREAM}`}>Cookie</Link></li>
              <li><Link to="/termini" className={`link-underline rounded-sm ${FOCUS_CREAM}`}>Termini</Link></li>
              <li><Link to="/note-legali" className={`link-underline rounded-sm ${FOCUS_CREAM}`}>Note legali</Link></li>
              <li><Link to="/disclosure" className={`link-underline rounded-sm ${FOCUS_CREAM}`}>Trasparenza</Link></li>
              <li>
                <a
                  href={`mailto:${LEGAL.contactEmail}`}
                  className={`link-underline rounded-sm ${FOCUS_CREAM}`}
                >
                  Contatti
                </a>
              </li>
              <li>
                <button
                  type="button"
                  className={`link-underline rounded-sm text-left ${FOCUS_CREAM}`}
                  onClick={openConsentPreferences}
                >
                  Preferenze cookie
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-10 border-t border-cream/15 max-w-md">
          <NewsletterForm source="footer" />
        </div>

        <div className="mt-16 pt-8 border-t border-cream/15 grid grid-cols-1 md:grid-cols-12 gap-6 text-[12px] text-cream/70">
          <p
            data-testid={IDS.footer.disclosure}
            className="md:col-span-8 leading-relaxed"
          >
            Alcuni link sono commerciali: {BRAND.name} potrebbe ricevere una
            commissione o vendere direttamente. Il prezzo per te non cambia.
          </p>
          <p className="md:col-span-4 md:text-right">
            © {new Date().getFullYear()} {BRAND.name}. Tutti i diritti riservati.
          </p>
        </div>

        <div className="mt-10 flex justify-center">
          <BrandLogo
            title="By DLPM"
            accent={false}
            boot={false}
            className="text-cream"
            wordClassName="text-lg md:text-xl leading-none tracking-tight"
          />
        </div>
      </div>
    </footer>
  );
}
